import { CIVS } from '../gameplay/civilisations';
import { PLAYER_COLORS, defaultConfig, type GameConfig } from '../engine/simulation/simulation';
import type { MapType } from '../world/maps/mapTypes';

/** Land maps for a first game: no long sea crossings, nothing that needs a navy to play well. */
export const QUICK_START_MAPS: MapType[] = ['continental', 'highlands', 'forest', 'desert', 'riverValley', 'coastal', 'mountainPass', 'openPlains'];

/**
 * Single Player: a game in one click. You against one Standard computer player on a random land
 * map (small), each side a random civilisation, Conquest or Wonder victory. Skirmish is the full
 * setup screen.
 */
export function quickStartConfig(playerName: string, rand: () => number = Math.random): GameConfig {
  const pick = <T,>(a: T[]): T => a[Math.floor(rand() * a.length) % a.length];
  const civs = CIVS.map((c) => c.key);
  const mine = pick(civs);
  const theirs = pick(civs.filter((c) => c !== mine));
  const cfg = defaultConfig({
    seed: Math.floor(rand() * 1e6),
    mapType: pick(QUICK_START_MAPS),
    mapSize: 'small',
    players: [
      { name: playerName, civ: mine, team: -1, color: PLAYER_COLORS[0] },
      { name: 'Computer 1', civ: theirs, team: -1, color: PLAYER_COLORS[1], ai: { difficulty: 'standard', personality: 'balanced' } },
    ],
  });
  cfg.victory.conditions = ['conquest', 'wonder'];
  return cfg;
}
